__turbopack_context__.v({
  "content": "Sidebar-module-scss-module__qeYgGW__content",
  "header": "Sidebar-module-scss-module__qeYgGW__header",
  "loading": "Sidebar-module-scss-module__qeYgGW__loading",
  "logo": "Sidebar-module-scss-module__qeYgGW__logo",
  "navbarBottomContainer": "Sidebar-module-scss-module__qeYgGW__navbarBottomContainer",
  "noResults": "Sidebar-module-scss-module__qeYgGW__noResults",
  "noResultsIcon": "Sidebar-module-scss-module__qeYgGW__noResultsIcon",
  "noResultsMessage": "Sidebar-module-scss-module__qeYgGW__noResultsMessage",
  "noResultsTitle": "Sidebar-module-scss-module__qeYgGW__noResultsTitle",
  "search": "Sidebar-module-scss-module__qeYgGW__search",
  "sidebarNav": "Sidebar-module-scss-module__qeYgGW__sidebarNav",
  "tree": "Sidebar-module-scss-module__qeYgGW__tree",
  "wrapper": "Sidebar-module-scss-module__qeYgGW__wrapper",
});
